import React from 'react'

import { Dashboard, PageLayout, useDashboardFeatureFlags } from '@components'
import { HeadContent } from '@fourthwall/components'
import { isWebView } from '@fourthwall/utils'

import { AnalyticsToolbar } from '../../analyticsModule/components/AnalyticsToolbar/AnalyticsToolbar'
import { AnalyticsCompareDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsCompareDateRangeSelect/AnalyticsCompareDateRangeSelect'
import { AnalyticsDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsDateRangeSelect/AnalyticsDateRangeSelect'
import { AnalyticsPrecisionSelect } from '../../analyticsModule/components/tools/AnalyticsPrecisionSelect/AnalyticsPrecisionSelect'
import { GoogleAnalyticsBanner } from '../../modules/GoogleAnalytics/components/GoogleAnalyticsBanner/GoogleAnalyticsBanner'
import { GoogleAnalyticsBar } from '../../modules/GoogleAnalytics/components/GoogleAnalyticsBar/GoogleAnalyticsBar'
import * as S from './AnalyticsReports.styled'
import { AnalyticsReportsData } from './components/AnalyticsReportsData/AnalyticsReportsData'
import { useAnalyticsReportsData } from './hooks/useAnalyticsReportsData'

export const AnalyticsReports = () => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const { data, isLoading, params, onExport } = useAnalyticsReportsData()

  return (
    <>
      <HeadContent title="Reports" titleTemplate={isWebView() ? 'Reports' : undefined} />
      <PageLayout size="full">
        <Dashboard.Section name={isWebView() ? undefined : 'Reports'}>
          <S.Container>
            <AnalyticsToolbar bottomContent={<GoogleAnalyticsBanner />}>
              <AnalyticsDateRangeSelect {...params.dateRange} />
              {dashboardFeatureFlags.analyticsV2Compare.enabled && (
                <AnalyticsCompareDateRangeSelect {...params.compareDateRange} />
              )}
              <AnalyticsPrecisionSelect {...params.precision} />
              <GoogleAnalyticsBar />
            </AnalyticsToolbar>
            <AnalyticsReportsData
              data={data}
              isLoading={isLoading}
              precision={params.precision.value.value}
              onExport={(reportId) => onExport({ reportId })}
            />
          </S.Container>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
